    <ul nz-menu nzTheme="light" nzMode="inline">
        <li nz-submenu nzTitle="{{'wh.step.artefacts'|translateTA}}" nzIcon="appstore">
            <ul>
                <div class="workflow-tool-wrapper" nz-flex [nzGap]="'middle'" [nzWrap]="'wrap'">
                @for ( item of artefacts; track item){
                
                    <div class="workflow-tool-item" fExternalItem [fData]="item"  [nz-tooltip]="item.text|translateTA">
                        <span class="material-symbols-outlined workflow-tool-icon" *ngIf="!item.svg">{{item.icon}}</span>
                        <nz-icon class="workflow-tool-icon" *ngIf="item.svg" [nzType]="'custom:' + item.icon"></nz-icon>
                        <!--div class="workflow-tool-item-text">{{item.text|translateTA}}</div-->
                    </div>
                }
                </div>
            </ul>
        </li>


        <li nz-submenu nzTitle="{{'wh.step.connectors'|translateTA}}" nzIcon="sliders">
            <ul>
                <div class="workflow-tool-wrapper" nz-flex [nzGap]="'middle'" [nzWrap]="'wrap'">
                @for ( item of connectors; track item){
                
                    <div class="workflow-tool-item" fExternalItem [fData]="item"  [nz-tooltip]="item.text|translateTA">
                        <span class="material-symbols-outlined workflow-tool-icon" *ngIf="!item.svg">{{item.icon}}</span>
                        <nz-icon class="workflow-tool-icon" *ngIf="item.svg" [nzType]="'custom:' + item.icon"></nz-icon>
                        <!--div class="workflow-tool-item-text"></div-->
                    </div>
                
                }
                </div>
            </ul>
        </li>

        <li nz-submenu nzTitle="{{'wh.step.template'|translateTA}}" nzIcon="branches">
            <ul>
            </ul>
        </li>
  
  